import { removeOrphanedInteriorPaletteOptionSet } from "../../options/paletteOptionSet";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_117: DocMigration = {
  maxSchemaVersion: "0.0.117",
  description:
    "Remove duplicate interior palette param with tag InteriorPalette and not SettingsParam + palettes + InteriorPalette",

  apply(json: any) {
    json.params = removeOrphanedInteriorPaletteOptionSet(json.params);

    return json;
  },
};

export default migration_0_0_117;
